import { Card, Form, Space } from 'antd';
import * as React from 'react';
import ChangeRequestDTO from '../../../models/ChangeRequestDTO';
import BaseChangeRequestProps from '../../../redux/bases/BaseChangeRequestProps';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import Guid from '../../../utils/Guid';
import ChangeRequestAdditionalDetailsForm from '../../forms/postSecondary/ChangeRequestAdditionalDetailsForm';
import ProgramDeactivationChangeRequestStep1Form from '../../forms/postSecondary/ProgramDeactivationChangeRequestStep1Form';

interface ProgramDeactivationChangeRequestDetailsState extends BaseFormState {
}

interface ProgramDeactivationChangeRequestDetailsProps extends BaseFormProps, BaseChangeRequestProps {
  changeRequest: ChangeRequestDTO;
}

class ProgramDeactivationChangeRequestDetails extends React.Component<ProgramDeactivationChangeRequestDetailsProps, ProgramDeactivationChangeRequestDetailsState> {

  constructor(props: ProgramDeactivationChangeRequestDetailsProps) {
    super(props);
  }

  public render = () => {
    return (
      <Form layout="vertical">
        <Space size="large" direction="vertical">
          <Card type='inner' title='Program Information'>
            <ProgramDeactivationChangeRequestStep1Form readonly={true} loading={this.props.loading} institutionId={this.props.changeRequest.institutionId ?? Guid.Empty()} changeRequestId={this.props.changeRequest.id} changeRequestDetailsPage={this.props.changeRequestDetailsPage} />
          </Card>

          <Card type="inner" size="small" title="Additional Details" >
            <ChangeRequestAdditionalDetailsForm readonly={true} changeRequest={this.props.changeRequest} loading={this.props.loading} />
          </Card>
        </Space>
      </Form >
    );
  }
}

export default ProgramDeactivationChangeRequestDetails;